"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const newGroupSchema = zod_1.z.object({
    name: zod_1.z.string().max(150),
    contacts: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.requestSchema = zod_1.z
    .object({
    groupsToCreate: zod_1.z.array(newGroupSchema).optional(),
    groupsToDelete: zod_1.z.array(zod_1.z.number()).optional(),
    groupsToUpdate: zod_1.z.record(zod_1.z.string(), newGroupSchema).optional(),
})
    .refine((args) => !!Object.keys(args).length, {
    message: 'Request object must contain at least one argument',
});
exports.path = '/groups-management';
//# sourceMappingURL=index.js.map